import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Auth.css';

const Login = () => {
  const { login, currentUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(location.state?.message || '');
  
  // Rediriger si l'utilisateur est déjà connecté
  useEffect(() => {
    if (currentUser) {
      navigate(`/profile/${currentUser.id}`);
    }
  }, [currentUser, navigate]);
  
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  
  const { email, password } = formData;
  
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    
    try {
      setLoading(true);
      const userData = await login(formData);
      
      // Vérifier que l'utilisateur a un ID valide
      if (!userData || (!userData.id && !userData._id)) {
        throw new Error('Impossible de récupérer les informations de l\'utilisateur');
      }
      
      // Rediriger vers le profil de l'utilisateur connecté
      navigate(`/profile/${userData.id}`);
    } catch (err) {
      console.error('Erreur lors de la connexion:', err);
      
      // Vérifier si l'erreur est liée à la vérification d'email
      if (err.needsVerification) {
        setError(
          <div>
            Veuillez vérifier votre adresse email avant de vous connecter.
            <div> 
            <button 
              className="btn btn-link p-0 ml-1" 
              onClick={() => navigate(`/verify-email`, { state: { email: formData.email } })}
            >
              Renvoyer l'email de vérification
            </button>
            </div>
          </div>
        );
      } else {
        setError(err.msg || err.message || 'Identifiants invalides');
      }
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="auth-page">
      <div className="container">
        <div className="auth-container">
          <div className="auth-card">
            <h2 className="auth-title">Se connecter</h2>
            <p className="auth-subtitle">Accédez à votre profil explorez RQM</p>
            
            {message && (
              <div className="alert alert-success">
                {message}
              </div>
            )}
            
            <form className="auth-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="email" className="form-label">Courriel</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="form-control"
                  value={email}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="password" className="form-label">Mot de passe</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  className="form-control"
                  value={password}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className="form-group text-right">
                <Link to="/forgot-password" className="forgot-password">
                  Mot de passe oublié?
                </Link>
              </div>
              
              {error && (
                <div className="alert alert-danger">
                  {error}
                </div>
              )}
              
              <button 
                type="submit" 
                className="btn btn-primary btn-block"
                disabled={loading}
              >
                {loading ? 'Connexion en cours...' : 'Se connecter'}
              </button>
            </form>
            
            <div className="auth-footer">
              <p>
                Vous n'avez pas de compte?{' '}
                <Link to="/register" className="auth-link">
                  S'inscrire
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
